import { Box as BoxParams } from '../../models/auto-generated-strapi-types/types/components/Box';
import {
  BoxWrapper,
  ImageWrapper,
  ContentWrapper,
  TitleWrapper,
  DescriptionWrapper,
  ButtonWrapper,
} from './Box.style';
import Button, { ButtonStyle } from '../button/Button';
import { PersonalizationBox } from '../../models/auto-generated-strapi-types/types/components/PersonalizationBox';
import { getPersonalizationAllAttributes } from '../../utils/style';
import { BoxSectionConfig } from '../../models/auto-generated-strapi-types/types/components/BoxSectionConfig';
import Link from 'next/link';

const Box: React.FC<any> = ({
  data,
  personalization,
  cols,
}: {
  data: BoxParams;
  personalization: PersonalizationBox[];
  cols: BoxSectionConfig;
}) => {
  return (
    <BoxWrapper cols={cols}>
      <ImageWrapper url={data?.image?.data?.attributes?.url}>
        <ContentWrapper>
          <TitleWrapper
            personalization={getPersonalizationAllAttributes(
              personalization,
              'title'
            )}
          >
            {data?.title}
          </TitleWrapper>
          <DescriptionWrapper
            personalization={getPersonalizationAllAttributes(
              personalization,
              'description'
            )}
          >
            {data?.description}
          </DescriptionWrapper>
          {data?.button?.url && (
            <ButtonWrapper>
              <Link href={data.button.url} passHref>
                <Button
                  text={data?.button?.text}
                  styleBtn={ButtonStyle?.primary}
                  asA={true}
                />
              </Link>
            </ButtonWrapper>
          )}
        </ContentWrapper>
      </ImageWrapper>
    </BoxWrapper>
  );
};

export default Box;
